
import Vue from 'vue'
import XTable from 'vux/src/components/x-table/index.vue'

var CollectionPage = Vue.extend({})
Vue.component('collection-page', CollectionPage)

export default {
  name: 'CollectionPage',
  components: {
    XTable
  },
  props: {
    idArr: Array
  },
  data () {
    return {
      baseUrl: this.$store.state.url,
      info: {}
    }
  },
  mounted () {
    this.axios({
      url: this.baseUrl+'/wechat/contract/getContrtactDetailJson/'+this.idArr[0],
      method: 'get'
    }).then((response) => {
      this.info = response.data.data.info;
    }).catch((response) => {
    });
  },
  methods: {

  }
}



// WEBPACK FOOTER //
// ./src/components/detail/todo/contract/collection.vue